import React from 'react';
import { Link } from 'react-router-dom';
import '../style/main.css';
import ProjectSlide from './ProjectSlide';

const Project = () => (
  <section className="project" id="Project">
    <h2>Project</h2>
    <div><Link to='https://github.com/choihwabin/choihwabin' title='화빈의 저장소' className='more' target="_blank" rel="noopener noreferrer">More</Link></div>
    <ProjectSlide />
  </section>
);

export default Project;
